<tt-page *ngIf="!!get">
    <tt-page-heading ttModel="p2_m_purchreceivalplanning" ttTranslate></tt-page-heading>
    <tt-card class="col-xs-12 col-md-12 sp-0" style="max-width: 1250px">
        <tt-select
            class="col-xs-12 col-md-6 sp-2"
            ttRememberId="purchreceivalplanning.stockplace_id"
            ttLabel="stockplace_id"
            ttLabelView="top"
            [(ttModel)]="get.stockplace_id"
            (ttModelChange)="grid?.gridfunc?.read?.()"
            [ttData]="stockplaces"
            ttDataName="stockplace_name"
            ttDataId="stockplace_id"
        ></tt-select>
        <form (submit)="grid?.gridfunc?.read?.()">
            <tt-input class="col-xs-12 col-md-6 sp-2" ttRememberId="purchreceivalplanning.purch_order_no" ttLabel="purch_order_no" ttLabelView="top" [(ttModel)]="get.purch_order_no"></tt-input>
            <!-- [ttButtons]="orderInternalNoButtons" -->
        </form>
        <tt-date-range
            class="col-xs-12 col-md-12 sp-2"
            ttRememberId="purchreceivalplanning"
            ttLabel="date_fom_tom"
            ttLabelView="top"
            [(ttStartDate)]="get.date_fom"
            [(ttEndDate)]="get.date_tom"
            [(ttInterval)]="get.dateselector_index"
            (ttModelChange)="grid?.gridfunc?.read?.()"
        ></tt-date-range>
    </tt-card>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    <tt-card *ngIf="get.show_settings === '1'" class="col-xs-12 sp-0">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
